import React, { useEffect, useState, useRef } from "react";
import { notification } from 'antd';
import dayjs from 'dayjs';
import { Base64 } from "js-base64";
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
    getPaymentWidgetById,
    addPaymentWidgetChargeById,
    paymentWidgetSplitUp,
    getHealthCheck,
    BASE_URLS,
    getQrPaymentReconnection,
    getSecretValuesById,
    getServerEncription,
    generateClientKeyPair,
    encryptData,
    getPayPalClientToken,
    getWalletOrderInfo,
    confirmWalletOrderInfo,
} from "../../api";
import { PAGES, MESSAGES, SWIREPAY_URL, TabNames, PAYMENT_WIDGET_STATUSES, QR_STATUSES, SESSION_TIME } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import { AmountDivideByHundred } from "../../helper";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import AlertModal from "../../components/modal/alert";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";
import ApplePay from "../../components/applePay/ApplePay";
import PayPalCheckout from "../paypalCheckout";
import RecaptchaModal from "../../components/recaptcha";
import Apple from '../../routes/apple';
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import { setFormData } from "../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";

type Props = {
    history: {
        push: Function,
    },
}

const WidgetPay = (props: Props) => {

    const { match: { params: { paymentwidgetlinkId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(['CARD']);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${paymentwidgetlinkId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [processStatus, setProcessStatus] = useState(false);
    const selectedData = localStorage.getItem('widgetInfo');
    const [customerInfo, setCustomerInfo] = useState(localStorage.getItem('widgetInfo') ? JSON.parse(localStorage.getItem('widgetInfo')) : null); 
    const [amountInfo, setAmountInfo] = useState();
    const [interval, setInterval] = useState('');
    const hostName = (window && window.location && window.location.host);
    let widgetsData;
    const [ipAddress, setIpAddress] = useState('');
    const [net, setNet] = useState(null);
    const [serviceFeeEnabled, setServiceFeeEnabled] = useState(false);
    const [feeService, setFeeService] = useState(null);
    const [totalPayable, setTotalPayable] = useState(null);
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [applePayAmount , setApplePayAmount] = useState()
    const [applePayment, setApplePayment] = useState(false);
    const [isApplePay, setIsApplePay] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const [googlePayUsRecurring, setGooglePayUsRecurring] = useState(false);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${paymentwidgetlinkId}`) || undefined);
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
    const [paymentLinkInstantPaymentGlobalRecaptcha, setPaymentLinkInstantPaymentGlobalRecaptcha] = useState(null);
    const [payPalClientAuth, setPayPalClientAuth] = useState('');
    const [payPalClientId, setPaypalClientId] = useState('');
    const commonRecaptchaToken = useRef(null);
    const [orderDatas, setOrderData] = useState();
    const dispatch = useDispatch();

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    }

    useEffect(() => {
        getData();
    }, []);

    const getPayPalAccountInfo = async (id) => {
        try {
            const payPalInfo = await getPayPalClientToken(id);
            const value = Base64.decode(payPalInfo);
            const value_json = JSON.parse(value);
            setPaypalClientId(value_json?.clientId);
            setPayPalClientAuth(payPalInfo);
            return payPalInfo;
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    useEffect(() => {
        if (payment?.account?.gid) {
            getPayPalAccountInfo(payment?.account?.gid);
        }
    }, [payment]);

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    useEffect(() => {
    if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
        if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
            if (payment?.name) {
              setPayment((prev) => ({...prev, name: updateCustomerRedux.customerDetails.name }));
            } else {
              setCustomerInfo((prev) => ({ ...prev, name: updateCustomerRedux.customerDetails.name }));
            }
        };
        if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
            if (payment?.email) {
              setPayment((prev) => ({...prev, email: updateCustomerRedux.customerDetails.email }));
            } else {
              setCustomerInfo((prev) => ({ ...prev, email: updateCustomerRedux.customerDetails.email }));
            }
        };
        if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
            && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1') {
            if (payment?.phoneNumber) {
              setPayment((prev) => ({...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
            } else {
              setCustomerInfo((prev) => ({ ...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
            }
        };
        dispatch(setUpdateStatus(false));
    };
      }, [updateCustomerRedux]);

    useEffect(() => {
        if (search) {
            getPaymentWidgetDataWithSearchValue()
        } else {
            getPaymentWidgetData();
        }
    }, [paymentwidgetlinkId, search]);

    useState(() => {
      if (window.ApplePaySession) {
        setIsApplePay(true);
      }
    }, []);

    const getGooglePayMerchantValues = async (accountGid) => {
        try {
            const values = await getSecretValuesById(accountGid, null);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support')
        }
    };

    useEffect(() => {
      const localStCustomer = localStorage.getItem('widgetInfo') ? JSON.parse(localStorage.getItem('widgetInfo')) : null;
      dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
          value: {
              phoneNumber: localStCustomer?.employDetails ? getCountryCodeAndNumber(localStCustomer?.employDetails)?.phoneNumber : '',
              countryCode: localStCustomer?.employDetails ? getCountryCodeAndNumber(localStCustomer?.employDetails)?.countryCode : '+1',
              name: `${localStCustomer?.firstName} ${localStCustomer?.lastName}`,
              email: localStCustomer?.email,
          } 
      }));
    }, []);

    useEffect(() => {
        setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
        setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
        setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
        setGooglePayUsRecurring(payment && payment.account && payment.account.supportedRecurringPaymentTypes.includes('GOOGLE_PAY_US'));
        if(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'))
            setSupportedPaymentTypes((prev) => [...prev, 'WALLET']);
        if(payment && payment.account && payment.account.supportedPaymentTypes.includes('ACH_LEGACY'))
            setSupportedPaymentTypes((prev) => [...prev, 'ACH_LEGACY']);
    }, [payment]);

    useEffect(() => {
        if (selectedData && payment) {
            widgetsData = JSON.parse(selectedData);
            setInterval(widgetsData.interval);
            setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
            setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
            setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
            setGooglePayUsRecurring(payment && payment.account && payment.account.supportedRecurringPaymentTypes.includes('GOOGLE_PAY_US'));
            setAmountInfo(`${currencyFormatter(AmountDivideByHundred(widgetsData.amount), payment.account.currency.name)}`);
            setApplePayAmount(widgetsData.amount)
            setSubmitBtnText(`${payment.paymentWidget.payButtonLabel} ${currencyFormatter(AmountDivideByHundred(widgetsData.amount), payment.account.currency.name)} ${widgetsData.interval}`)
        }
    }, [selectedData, payment]);

    useEffect(() => {
        setErrorMessage(null);
    }, [selectedTab]);

    const getPaymentWidgetDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getPaymentWidgetById(paymentwidgetlinkId, search);
            if (value) {
                const { status } = value.paymentWidget;
                widgetsData = JSON.parse(selectedData);
                value.currency = value?.account?.currency;
                value.amount = widgetsData.amount;
                setPayment(value);
                if (value?.phoneNumber) {
                    dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                        value: {
                            phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
                            countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
                            name: value?.name,
                            email: value?.email,
                        } 
                    }));
                }
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid);
                }
                if (PAYMENT_WIDGET_STATUSES.ACTIVE === status) {
                    setTransactionModalOpen(false);
                    setTransactionSuccessModalOpen(true);
                    setTimeout(function () {
                        sessionStorage.setItem('fromWidget', true);
                        props.history.push(`${PAGES.PAYMENT_WIDGET}/${paymentwidgetlinkId}`);
                    }, 5000);
                }
            }
        } catch (reason) {
            try {
                const value = await getPaymentWidgetById(paymentwidgetlinkId);
                if (value) {
                    const { status } = value.paymentWidget;
                    if (PAYMENT_WIDGET_STATUSES.ACTIVE !== status) {
                        props.history.push(`${pathname}/expired`);
                        return;
                    }
                    value.currency = value?.account?.currency;
                    widgetsData = JSON.parse(selectedData);
                    value.amount = widgetsData.amount;
                    setPayment(value);
                    if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
                        getGooglePayMerchantValues(value && value.account && value.account.gid);
                    }
                    if (value.account && value.account.portal) {
                        const portal = value.account.portal.test;
                        setIsTest(portal);
                        supportedBankTypes(value.account.supportedPaymentTypes);
                    }
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        if (!reason) return;
        const { data: { message, messageCode }, status } = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    };

    const getSplitUp = async (id, payload, info) => {
        try {
            const value = await paymentWidgetSplitUp(id, payload);
            setNet(value.amount || 0);
            setFeeService(value.serviceFee || 0);
            setTotalPayable(value.totalPayable || 0);
            setAmountInfo(`${currencyFormatter(AmountDivideByHundred(value.totalPayable), info.account.currency.name)}`);
            setSubmitBtnText(`${info.paymentWidget.payButtonLabel} ${currencyFormatter(AmountDivideByHundred(value.totalPayable), info.account.currency.name)} ${widgetsData.interval}`)
        } catch (reason) {
            error(reason);
        }
    }

    const getPaymentWidgetData = async () => {
        setShowSpinner(true);
        try {
            const value = await getPaymentWidgetById(paymentwidgetlinkId, null);
            if (value) {
                const { status } = value.paymentWidget;
                if (PAYMENT_WIDGET_STATUSES.ACTIVE !== status) {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                widgetsData = JSON.parse(selectedData);
                value.currency = value?.account?.currency;
                value.amount = widgetsData.amount;
                setPayment(value);
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid);
                }
                if ((value && value.paymentWidget && value.paymentWidget.serviceFeeEnabled) === true) {
                    setServiceFeeEnabled(value && value.paymentWidget && value.paymentWidget.serviceFeeEnabled);
                    getSplitUp(paymentwidgetlinkId, widgetsData.amount, value);
                }
                if (value.account && value.account.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                }
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment && payment.customer && payment.customer.gid;
    };

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod, notify } = data;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod, notify } = data;
        widgetsData = JSON.parse(selectedData);
        await chargeById({ 
            customerDetails: customer, 
            paymentMethodDetails: paymentMethod,
            shouldWhatsAppNotify: notify, 
            customerGid: getCustomerGidFromPayment(payment),
            companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false, 
            amount: widgetsData.amount,
            interval: widgetsData.interval,
            remarks: widgetsData.remarks || '',
        });
    };

    const chargeBySavedPaymentMethods = async (data) => {
      await chargeById({
        paymentMethodDetails: data,
        amount: widgetsData.amount,
        interval: widgetsData.interval,
        remarks: widgetsData.remarks || '',
      });
    };

    const chargeByCard = async (data) => {
        const { paymentMethod } = data;
        widgetsData = JSON.parse(selectedData);
        const paymentData = {
            companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
            employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
            employeeEmail: widgetsData.email,
            employeeFirstName: widgetsData.firstName,
            employeeLastName: widgetsData.lastName,
            paymentMethodDetails: paymentMethod,
            interval: widgetsData.interval,
            amount: widgetsData.amount,
            remarks: widgetsData.remarks || '',
            customerDetails: {
                email: widgetsData.email,
                name: `${widgetsData.firstName} ${widgetsData.lastName}`,
                phoneNumber: widgetsData?.employDetails,
                taxId: 'NONE',
                taxStatus: 'TAXABLE'
            }
        };
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentData.userAgent = userAgent;
        await chargeById(paymentData);
    };

    const chargeByBank = async (data) => {
        const { fundingSourceId } = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByNetBanking = async (data) => {
        const { gid, notify } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias, notify } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeBySwirepayUS = async (data) => {
        const { walletAlias, notify } = data;
        widgetsData = JSON.parse(selectedData);
        const paymentMethod = {
            type:"WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        const payload = {
            companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
            employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
            employeeEmail: widgetsData.email,
            employeeFirstName: widgetsData.firstName,
            employeeLastName: widgetsData.lastName,
            paymentMethodDetails: paymentMethod, 
            shouldWhatsAppNotify: notify, 
            interval: widgetsData.interval, 
            amount: widgetsData.amount,
            remarks: widgetsData.remarks || '',
            customerGid: getCustomerGidFromPayment(payment)
        }
        await chargeById(payload);
    };

    const chargeByApple = async (paymentData) => {
      const {
        deviceData,
        amount,
        // customerName,
        // customerEmail,
        // customerPhone,
        countryCode,
        stateCode,
        street,
        postalCode,
        city,
        cardNetwork,
        cardType,
        cardLast4,
      } = paymentData;
        const billingAddress = {
          city: city,
          countryCode: countryCode,
          state: stateCode,
          street: street
        };
      const paymentMethod = {
        applePayUS: {
          deviceData: deviceData,
          cardBrand: cardNetwork,
          cardFundingType: cardType,
          applePayDynamicLast4: cardLast4,
          cardLast4: cardLast4
        },
        type: "WALLET",
        subType: "APPLE_PAY_US",
        postalCode: postalCode,
        paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
      }
      await chargeById({ paymentMethodDetails: paymentMethod, amount:parseFloat(amount.replace(/,/g, '') * 100),interval:interval, customerGid: getCustomerGidFromPayment(payment) });  
    }

    const chargeByCardpointeApplePay = async (paymentData) => {
        const {
            deviceData,
            amount,
            // customerName,
            // customerEmail,
            // customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
      
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };

        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }

        // let customer = {
        //     email: customerEmail,
        //     name: customerName,
        //     phoneNumber: customerPhone,
        // }

        await chargeById({
            paymentMethodDetails: paymentMethod,
            amount: parseFloat(amount.replace(/,/g, '') * 100),
            interval: interval,
            customerGid: getCustomerGidFromPayment(payment),
        });  
    };

    const chargeByApplePay = async (stripePaymentMethod) => {
      // const meta = stripePaymentMethod;
      const paymentMethod = {
        applePayUS: {
              stripePaymentMethodId: stripePaymentMethod.id,
              cardBrand: stripePaymentMethod.card.brand,
              cardExpMonth: stripePaymentMethod.card.exp_month,
              cardExpYear: stripePaymentMethod.card.exp_year,
              cardFundingType: stripePaymentMethod.card.funding,
              applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
              cardLast4: stripePaymentMethod.card.last4,
              billingAddress: {
                street: stripePaymentMethod.billing_details.address.line1,
                city: stripePaymentMethod.billing_details.address.city,
                state: stripePaymentMethod.billing_details.address.state,
                postalCode: stripePaymentMethod.billing_details.address.postal_code,
                countryCode: stripePaymentMethod.billing_details.address.country
              },
              name: stripePaymentMethod.billing_details.name,
              email: stripePaymentMethod.billing_details.email,
              phone: stripePaymentMethod.billing_details.phone
            },
            customerGid: getCustomerGidFromPayment(payment),
            type: "WALLET",
            subType: "APPLE_PAY_US",
            rawData: {
              stripePaymentMethodId: stripePaymentMethod.id,
              cardBrand: stripePaymentMethod.card.brand,
              cardExpMonth: stripePaymentMethod.card.exp_month,
              cardExpYear: stripePaymentMethod.card.exp_year,
              cardFundingType: stripePaymentMethod.card.funding,
              applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
              cardLast4: stripePaymentMethod.card.last4,
              billingAddress: {
                street: stripePaymentMethod.billing_details.address.line1,
                city: stripePaymentMethod.billing_details.address.city,
                state: stripePaymentMethod.billing_details.address.state,
                postalCode: stripePaymentMethod.billing_details.address.postal_code,
                countryCode: stripePaymentMethod.billing_details.address.country
              },
              name: stripePaymentMethod.name,
              email: stripePaymentMethod.email,
              phone: stripePaymentMethod.phone
            }
          };
      await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
  };

    const chargeById = async (paymentDetails, recaptchaToken = null) => {
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(paymentDetails), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const response = await addPaymentWidgetChargeById(paymentwidgetlinkId, payload);
                        setSavedPaymentDetails(null);
                        setRecaptchaModalVisible(false);
                        const value = response?.data?.entity;
                        if (value) {
                            let paymentUrl;
                            let redirectUrl;
                            if (interval === 'ONETIME') {
                                paymentUrl = value.paymentSession;
                            } else if (interval !== 'ONETIME') {
                                paymentUrl = value.subscription;
                            }
                            if (paymentUrl) {
                                const { nextActionUrl } = paymentUrl;
                                redirectUrl = paymentUrl.returnUrl;
                                if (nextActionUrl) {
                                    window.location = nextActionUrl;
                                    return;
                                }
                            }
                            setTransactionModalOpen(false);
                            if (!value?.paymentSession || (value?.paymentSession?.status === 'SUCCEEDED') || (value?.paymentSession?.status === 'REQUIRE_CONFIRMATION') || (value?.paymentSession?.status === 'PROCESSING') || (value?.paymentSession?.status === 'REQUIRE_ACTION')) {
                                setTransactionSuccessModalOpen(true);
                                if (value?.paymentSession?.status === 'REQUIRE_CONFIRMATION') {
                                  setManualPlaidPayment(true);
                                }
                                const timeOut = value?.paymentSession?.status === 'REQUIRE_CONFIRMATION' ? SESSION_TIME.MANUAL_PLAID : 5000;
                                setTimeout(function () {
                                    if (redirectUrl) {
                                        window.location = redirectUrl;
                                    } else if (!redirectUrl) {
                                        sessionStorage.setItem('fromWidget', true);
                                        props.history.push(`${PAGES.PAYMENT_WIDGET}/${paymentwidgetlinkId}`);
                                    }
                                }, timeOut);
                                if (paymentwidgetlinkId) { localStorage.removeItem(`${paymentwidgetlinkId}-tap-index`) }
                            } else {
                                setErrorMessage('An error occured');
                            };
                        }
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429) {
                setSavedPaymentDetails(paymentDetails);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
            case TabNames.UPI:
                setPaymentLinkUpiGlobalRecaptcha(token);
                break;
            case TabNames.INSTANT_PAYMENT:
                setPaymentLinkInstantPaymentGlobalRecaptcha(token);
                break;
            case 'payPalButton':
                commonRecaptchaToken.current = token;
                break;
            default:
                await chargeById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    }

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
          const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
          if (value) {
            const { status, receiptNumber } = value;
            const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
            if (status === QR_STATUSES.SUCCEEDED) {
              if (!redirectionUri) {
                setTransactionSuccessModalOpen(true);
              }
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                const redirectUrl = redirectionUri ? redirectionUri : '';
                const urlPath = redirectUrl.includes("?");
                if (urlPath) {
                  window.location = `${redirectUrl}&sp-payment-button=${paymentwidgetlinkId}`;
                } else if (!urlPath && redirectUrl) {
                  window.location = `${redirectUrl}?sp-payment-button=${paymentwidgetlinkId}`;
                } else if (uri && !redirectUrl) {
                  window.location = `${uri}receipts/${receiptNumber}`;
                }
              }, timeOut);
              if (paymentwidgetlinkId) { localStorage.removeItem(`${paymentwidgetlinkId}-tap-index`) }
            }
          }
        } catch (reason) {
          error(reason);
        }
      };
    

    const chargeByGooglePay = async (data) => {
        widgetsData = JSON.parse(selectedData);
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };

        await chargeById({
            companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
            employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
            employeeEmail: widgetsData.email,
            employeeFirstName: widgetsData.firstName,
            employeeLastName: widgetsData.lastName,
            paymentMethodDetails: paymentMethod,
            interval: widgetsData.interval,
            amount: widgetsData.amount,
            remarks: widgetsData.remarks || '',
            customerDetails: {
                email: widgetsData.email,
                name: `${widgetsData.firstName} ${widgetsData.lastName}`,
                phoneNumber: widgetsData?.employDetails,
                taxId: 'NONE',
                taxStatus: 'TAXABLE'
            }
        });
    };

    const onApprove = async (data) => {
        try {
          await confirmWalletOrderInfo(orderDatas?.paymentSession?.gid, orderDatas?.paymentSession?.psClientSecret);
          setTransactionSuccessModalOpen(true);
          const timeOut = SESSION_TIME.NO_REDIRECT_URL;
          setTimeout(function () {
            window.location = SWIREPAY_URL;
          }, timeOut);
        } catch (error) {
          console.error(error);
          throw error;
        }
      };
    
      const createOrder = async (paypalData, actions) => {
        try {
        widgetsData = JSON.parse(selectedData);
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
          const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
          if (values?.public_key) {
            const keys = generateClientKeyPair();
            if (keys?.privateKey) {
              let data = {};
              if (paypalData?.paymentSource === 'paypal') {
                  data = {
                      userAgent: userAgent,
                      companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
                      employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
                      employeeEmail: widgetsData.email,
                      employeeFirstName: widgetsData.firstName,
                      employeeLastName: widgetsData.lastName,
                      interval: widgetsData.interval,
                      amount: widgetsData.amount,
                      remarks: widgetsData.remarks || '',
                      customerDetails: {
                          email: widgetsData.email,
                          name: `${widgetsData.firstName} ${widgetsData.lastName}`,
                          phoneNumber: widgetsData?.employDetails,
                          taxId: 'NONE',
                          taxStatus: 'TAXABLE'
                      },
                      paymentMethodDetails: {
                          payPalWallet: {
                              rawData: {
                                  experience_context: {
                                      payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                      landing_page: "LOGIN",
                                      return_url: SWIREPAY_URL,
                                      cancel_url: SWIREPAY_URL,
                                  }
                              }
                          },
                          type: "WALLET",
                          subType: "PAYPAL_WALLET"
                      }
                  }
              } else if (paypalData?.paymentSource === 'venmo') {
                  data = {
                      userAgent: userAgent,
                      companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
                      employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
                      employeeEmail: widgetsData.email,
                      employeeFirstName: widgetsData.firstName,
                      employeeLastName: widgetsData.lastName,
                      interval: widgetsData.interval,
                      amount: widgetsData.amount,
                      remarks: widgetsData.remarks || '',
                      customerDetails: {
                          email: widgetsData.email,
                          name: `${widgetsData.firstName} ${widgetsData.lastName}`,
                          phoneNumber: widgetsData?.employDetails,
                          taxId: 'NONE',
                          taxStatus: 'TAXABLE'
                      },
                      paymentMethodDetails: {
                          venmo: {
                              rawData: {
                                  experience_context: {
                                      payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                      landing_page: "LOGIN",
                                      return_url: SWIREPAY_URL,
                                      cancel_url: SWIREPAY_URL,
                                  }
                              }
                          },
                          type: "WALLET",
                          subType: "VENMO"
                      }
                  }
              }
              const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
              const payload = {
                publicKey: keys?.publicKey,
                keyId: encriptedData?.keyId,
                iv: encriptedData?.iv,
                data: encriptedData?.encryptedData,
              }
              if (encriptedData?.keyId) {
                const {data : { entity } } = await addPaymentWidgetChargeById(paymentwidgetlinkId, payload);
                commonRecaptchaToken.current = null;
                if (entity?.paymentSession?.gid) {
                  setOrderData(entity)
                  const orderData = await getWalletOrderInfo(entity?.paymentSession?.gid, entity?.paymentSession?.psClientSecret);
                  if (!orderData.id) {
                    const errorDetail = orderData.details[0];
                    const errorMessage = errorDetail
                      ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                      : "Unexpected error occurred, please try again.";
    
                    throw new Error(errorMessage);
                  }
                  return orderData?.id;
                }
              }
            }
          }
        } catch (error) {
          if (error?.status === 429) {
            setSavedPaymentDetails(paypalData);
            setRecaptchaPaymentType('payPalButton');
            setRecaptchaModalVisible(true);
            setTransactionModalOpen(false);
            throw new Error('Recatpcha Required');
          }
          console.error(error);
          throw error || new Error('Unexpected error occurred, please try again.');
        }
      };

    const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    if(uniquePaymentTypes.includes('WALLET')) {
        if (swirepayUS && interval === 'ONETIME') {
            uniquePaymentTypes.push('SWIREPAY_US');
        }
        if((!googlePayUs && interval === 'ONETIME') || (!googlePayUsRecurring && interval !== 'ONETIME')){
            const index = uniquePaymentTypes.indexOf('WALLET');
            if (index > -1) {
                uniquePaymentTypes.splice(index, 1);
            }
        }
    }
    
    const getCustomerData = () => {
      let customerData = null;
      if (payment?.name) {
         return payment
      } else if (customerInfo) {
        customerData = { 
            name: customerInfo?.name ? customerInfo?.name : `${customerInfo?.firstName} ${customerInfo?.lastName}`,
            phoneNumber: customerInfo?.employDetails,
            email: customerInfo?.email
        }
      }
      return customerData;
    };

    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;
        if (name === TabNames.ACH_LEGACY) {
            widgetsData = JSON.parse(selectedData);
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={getCustomerData()}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={paymentwidgetlinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true} 
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={amountInfo || null}
            />
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                hideCustomer={true}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={getCustomerData()}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={false}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                chargeByApplePay={chargeByApplePay}
                ApplePayment={applePayment}
                clearZipCode={true}
            />
            id = name;
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={getCustomerData()}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                showMobileViewUpi={true}
                hideQr={false}
                showWhatsAppNotify={false}
                getPaymentById={null}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                upiUrl={null}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={getCustomerData()}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                showWhatsAppNotify={false}
                paymentwidgetlinkId={paymentwidgetlinkId}
                iavUrl={null}
                customerValidation={true}
                cancelButtonText={"Decline"}
                requiredPhone={false}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
            />
            id = name;
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={getCustomerData()}
                showWhatsAppNotify={false}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
            id = name;
        } else if (name === TabNames.APPLE_PAY_US) {
          children = <ApplePay
              headerText={"PAY WITH APPLE PAY"}
              payment={{amount: totalPayable && totalPayable, currency: payment.currency}}
              chargeByApplePay={chargeByApplePay}
              gpayError={null}
              errorMsg={errorMessage}
              errorHeader={null}
          />
          id = name;
      } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
            id = name;
        } else if (name === TabNames.WALLET) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
            id = name;
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={null}
                showWhatsAppNotify={false}
                upiUrl={null}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else if (name === TabNames.SWIREPAY_US) {
            widgetsData = JSON.parse(selectedData);
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeBySwirepayUS}
                getPaymentById={getQrPaymentById}
                preFillCustomer={getCustomerData()}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                showWhatsAppNotify={false}
                upiUrl={`${BASE_URLS.PAYMENT_WIDGET}/${paymentwidgetlinkId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                swirepayUS={swirepayUS}
                paymentInterval={interval}
                paymentMethodDetails={true}
                amount={widgetsData?.amount}
                paymentWidget={true}
                employeeDetails={{
                    companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
                    employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
                    employeeEmail: widgetsData.email,
                    employeeFirstName: widgetsData.firstName,
                    employeeLastName: widgetsData.lastName
                }}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children, id });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                hideCustomer={true}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={false}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                chargeByApplePay={chargeByApplePay}
                ApplePayment={applePayment}
                clearZipCode={true}
            />,
            id: 'CARD'
        }
    ];
// Ensure that `interval` and `isApplePay` are defined in the current scope
console.log(interval , "inteval")
    
const tabPanelsApple = {
    children: applePayment && isApplePay && interval && interval === "ONETIME"
      ? <Apple amount={applePayAmount} chargeByApple={chargeByCardpointeApplePay} payment={payment} /> 
      : null,
    id: applePayment && isApplePay && interval && interval === "ONETIME" ? 'APPLE_PAY_US' : null
  };

  tabPanels.push(tabPanelsApple);

  if (payment?.account?.country?.alpha2 === 'US') {
    tabPanels.push({
    children: <SavedPaymentMethods
                buttonText={submitBtnText}
                submit={chargeBySavedPaymentMethods}
                supportedPaymentTypes={uniquePaymentTypes}
                />,
    id: 'SAVED_PAYMENT_METHODS'
    });
  }

  if (payPalClientAuth && payPalClientId) {
    tabPanels.push({
      children: <div style={{ width: '200px'}} >
      <PayPalCheckout
        styles={{ shape: "rect", layout: "vertical" }}
        createOrder={createOrder}
        onApprove={onApprove}
        payPalClientId={payPalClientId}
        currency={payment?.account?.currency?.name || 'USD'}
        country={payment?.account?.country?.alpha2 || 'US'}
      />
      </div>,
      id: 'PAYPAL_METHOD',
    });
    uniquePaymentTypes.push('PAYPAL_METHOD');
  }



    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;
    return (
        <BaseSplitPage
        errorHeader={null}
        errorMsg={errorMessage}
        left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                            )
                        }
                        <H1Text>
                            Payment Checkout
                        </H1Text>
                        <H2Text>
                            Amount Payable
                        </H2Text>
                        <DescriptionText fontSize="24px">
                            {amountInfo || null}
                        </DescriptionText>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={payment && payment.support && payment.support.email}
                            phone={payment && payment.support && payment.support.phone}
                            partnerImageUrl={partnerImageUrl}
                            bankImageUrl={bankImageUrl}
                            whiteLabel={payment && payment.account && payment.account.whiteLabel}
                        />
                        {agregatorName === 'EPAYMENTS' ?
                            <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                <a href="https://www.swirepay.com" target="_blank" >
                                    <img src={EPaymentImg} alt="" />
                                </a>
                            </div>
                            :
                            agregatorName === 'OMEGAITR' ?
                                <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                    <a href="https://www.swirepay.com" target="_blank" >
                                        <img src={OMEGAITRlogo} alt="" />
                                    </a>
                                </div>
                                :
                                ''
                        }
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header 
                    payment={amountInfo} 
                    bankImageUrl={bankImageUrl}
                    cancelUrlLink={null}
                />
                {payment?.account?.country?.alpha2 === 'US' ? (
                  <PaymentExpandableRowsV2
                    id={paymentwidgetlinkId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay ={isApplePay}
                    interval={interval}
                    accountGid={payment?.account?.gid}
                />) : (
                  <PaymentExpandableRows
                    id={paymentwidgetlinkId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay ={isApplePay}
                    interval={interval}
                    accountGid={payment?.account?.gid}
                />
                )}
                <RecaptchaModal
                    visible={recaptchaModalVisible}
                    onVerified={onGlobalCaptchaVerified}
                />
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} manualPlaidPayment={manualPlaidPayment} />
                <AlertModal
                    showIcon={alertConfig.showIcon}
                    isOpen={alertConfig.isOpen}
                    hideBtn={alertConfig.hideBtn}
                    cancel={alertConfig.cancel}
                    header={alertConfig.header}
                    body={alertConfig.body}
                    submitBtnText={alertConfig.submitBtnText}
                    cancelBtnText={alertConfig.cancelBtnText}
                    showCancelBtn={alertConfig.showCancelBtn}
                    showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon} />
                <Spinner isOpen={isShowSpinner} />
            </>
        } />
    )
};

export default WidgetPay;